<template>
  <base-stat-item :metric="metric" label="Clicks">
    <template v-slot:icon>
      <clicks-icon></clicks-icon>
    </template>
  </base-stat-item>
</template>
<script>
import BaseStatItem from './BaseStatItem.vue';
import ClicksIcon from '../Icons/ClicksIcon.vue';

export default {
  props: {
    metric: [String, Number]
  },
  components: {
    BaseStatItem,
    ClicksIcon
  },
};
</script>
